import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { SecurityCodeForm } from "../../../../pages/authentication/securityPinCode/securityCodeForm";
import { verifyPinCode } from "../../../../setup/api/services/user";
import { AuthConfig } from "../../../../setup/context/config/authConfig";
import PrimaryButton from "../../../common/PrimaryButton";
import Alert, { AlertType } from "../../../common/WaffyAlert/WaffyAlert";
// pinCode
import styles from "./pinCode.module.scss";

interface IConfirmPinCodeModalProps {
  description: string;
  onConfirm: any;
}
export const ConfirmPinCodeForm = (props: IConfirmPinCodeModalProps) => {
  const { id } = AuthConfig.getUserInfo();
  const { description, onConfirm } = props;
  const [securityCode, setSecurityCode] = useState<string>();
  const [error, setError] = useState<string>();
  useEffect(() => {
    setError(undefined);
  }, [securityCode]);

  const { t } = useTranslation();
  const onClick = () => {
    if (securityCode) {
      verifyPinCode(id, { pinCode: securityCode }).then((res) => {
        if (res.data.valid) {
          onConfirm();
        } else setError(t("lbl_verify_pin_code_error"));
      });
    }
  };
  return (
    <div style={{ marginTop: "8px" }}>
      <div>
        <div>
          <div className={styles.modalDescription}>{description}</div>
        </div>
        <div dir="rtl">
          <div>
            {error && <Alert type={AlertType.ERROR}>{error}</Alert>}

            <SecurityCodeForm
              onChange={setSecurityCode}
              pinCode={{
                background: "#FFFFFF",
                border: `1px solid #E7E9EA`,
                borderRadius: `8px`,
                fontFamily: "IBM Plex Sans Arabic",
                fontWeight: 700,
                fontSize: "48px",
                color: "#000000",
              }}
            />
          </div>
        </div>
        <div className={styles.mt12}>
          <PrimaryButton id={`contract_details_verify_pin`} onClick={onClick}>
            {t("lbl_confirm")}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};
